export default "__VITE_ASSET__529a3e49__"